import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import SEO from "@/components/SEO";
import { WA_ORDER } from "@/data/business";

export default function NotFound() {
  return (
    <>
      <SEO title="الصفحة غير موجودة | نجم الإطار — بنشر متنقل الرياض" description="الصفحة المطلوبة غير موجودة — عُد للرئيسية أو تواصل معنا 0538644740 لطلب بنشر متنقل في الرياض." path="/404" />
      <section className="min-h-[70vh] flex items-center justify-center pt-24">
        <div className="text-center px-4">
          <p className="font-mono text-gold text-6xl font-bold mb-4">404</p>
          <h1 className="font-display font-black text-white text-3xl mb-4">الصفحة غير موجودة</h1>
          <p className="text-gray-400 mb-8">ربما انتقل الرابط — لكن فريق البنشر المتنقل لا يزال في الطريق إليك.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/" className="bg-gold hover:bg-gold-deep text-ink font-extrabold rounded-full px-7 py-3 transition-colors" data-testid="notfound-home">
              العودة للرئيسية
            </Link>
            <a href={WA_ORDER} target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-deep text-ink font-extrabold rounded-full px-7 py-3 transition-colors inline-flex items-center gap-2" data-testid="notfound-order">
              <MessageCircle size={16} /> اطلب بنشر متنقل عبر واتساب
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
